var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filterId)?_c('div',[_c('EnvieHeader',{attrs:{"color":"purple","filter-id":_vm.filterId}}),_c('FavouriteContent',{attrs:{"partner-id":_vm.partnerId},on:{"loaded":function($event){_vm.scrollInitialized = true}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }